import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const FaqListHeader = ({
  refreshHandler = () => {},
  updateBulkHandler = () => {},
  deleteMassiveHandler = () => {},
}) => {
  const { t } = useTranslation(); //for translation
  /* ---- bread crumb text ---- */
  const breadcrumbText = [{ title: t("Faq") }];
  return (
    <div className="bg-white pt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadcrumbText} top={false} />
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          {/* <!-- ========== Start refresh Section ========== --> */}
          <Link
            onClick={refreshHandler}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          {/* <!-- ========== End refresh Section ========== --> */}

          {/* ------ search icon start ------ */}
          <Link
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            data-bs-toggle="offcanvas"
            data-bs-target="#searchFaqOffcanvas"
            aria-controls="searchFaqOffcanvas"
          >
            <span className="d-block material-symbols-outlined icon-md me-1">
              search
            </span>
            <span className="fw-semibold small">{t("Search")}</span>
          </Link>
          {/* ------ search icon end ------ */}

          {/* <!-- ========== Start Action Dropdown Section ========== --> */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              {/* ----- add tag modal section start -----  */}
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  data-bs-toggle="modal"
                  data-bs-target="#addLabelModal"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    label
                  </span>
                  <span className="d-block">{t("Add Label")}</span>
                </Link>
              </li>
              {/* ----- add tag modal section end -----  */}

              {/* ----- update rank section start -----  */}
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  onClick={updateBulkHandler}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    progress_activity
                  </span>
                  <span className="d-block">{t("Update Rank")}</span>
                </Link>
              </li>
              {/* ----- update rank section end -----  */}

              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  onClick={() => {
                    updateBulkHandler("approve");
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    book
                  </span>
                  <span className="d-block">{t("Approve to publish")}</span>
                </Link>
              </li>

              {/* ----- delete status section start -----  */}
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  data-bs-toggle="modal"
                  data-bs-target="#deletewarning"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Delete")}</span>
                </Link>
              </li>
              {/* ----- delete status section end -----  */}

              {/* ----- upload document based faq -----  */}
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  data-bs-toggle="modal"
                  data-bs-target="#create_faq_from_doc"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    upload_file
                  </span>
                  <span className="d-block">{t("Generate FAQ ")}</span>
                </Link>
              </li>
              {/* ----- end upload document based faq -----  */}

              {/* ----- Index FAQ -----  */}
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  data-bs-toggle="modal"
                  data-bs-target="#indexingWarning"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    search
                  </span>
                  <span className="d-block">{t("Index FAQ for search")}</span>
                </Link>
              </li>
              {/* ----- end indexed faq -----  */}
            </ul>
          </div>
          {/* <!-- ========== End Action Dropdown Section ========== --> */}

          {/* ------ show search filter link start ------ */}
          <Link
            to="#"
            className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasFaqFilter"
            aria-controls="offcanvasFaqFilter"
          >
            <span className="d-block material-symbols-outlined icon-md me-1">
              tune
            </span>
            <span className="fw-semibold small">{t("Filter")}</span>
          </Link>
          {/* ------ show search filter link end ------ */}

          {/* ------ add new blog link start ------ */}
          <Link
            to="#"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveFaqOffcanvas"
            aria-controls="saveFaqOffcanvas"
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
          >
            <span className="d-block material-symbols-outlined icon-md">
              add
            </span>
            <span className="d-block">{t("Add New")}</span>
          </Link>
          {/* ------ add new blog link end ------ */}
        </div>
      </div>
    </div>
  );
};

export default FaqListHeader;
